export enum Animations {
  None = 'None',
  Fade = 'Fade',
  ScaleRight = 'ScaleRight',
  ScaleLeft = 'ScaleLeft',
  Slide = 'Slide'
}
